import { Link } from 'react-router-dom';
import { dataStore } from '../Store';
import consts from '../consts';
import Model from '../models/model';
import TaskBluePng from '../styles/img/assets/task blue.png';

const getLicenseType = () => {
	const { tags } = dataStore.getState().auth || {};
	return !tags?.LicenseAppName?.includes('catviewer');
};

const taskIconRenderer = (params) => {
	return (
		<Link sx={{ width: '25px', height: '25px' }} to={`/dashboardtasks?EquipmentId=${params.value}`}>
			<img src={TaskBluePng} alt="Task Icon" />
		</Link>
	);
};

const wellNumber = (value) => (value > 0 ? value : 'NA');

const model = new Model({
	name: 'DashBoardEquipment',
	idProperty: '_id',
	defaultSort: 'LastConnection DESC',
	formTitleField: 'EquipmentName',
	gridTitle: 'Equipment',
	disableDelete: true,
	disableAdd: true,
	backgroundApi: 'true',
	showGridRefreshBtn: true,
	readOnly: ({ location }) => ['/dashboard', '/modalitydashboard'].includes(location?.pathname),
	disableExport: ({ location }) => ['/dashboard', '/modalitydashboard'].includes(location?.pathname),
	disableColumnSelector: ({ location }) => ['/dashboard', '/modalitydashboard'].includes(location?.pathname),
	disableFiltering: ({ location }) => ['/dashboard', '/modalitydashboard'].includes(location?.pathname),
	hideGridFooter: ({ location }) => ['/dashboard', '/modalitydashboard'].includes(location?.pathname),
	filterColumns: ({ grid, isFromEquipmentDetail }) => {
		const hideColumns = [];
		if (grid && isFromEquipmentDetail) {
			hideColumns.push('FirmwareRevision', 'WellCount');
		}
		return { hideColumns };
	},
	initialValues: {
		IsActive: true,
		TransferPdf: true,
		LanguageCodeId: '6124ce10677de3668816e646'
	},

	comboTypes: [
		{ type: 'Location', loaded: true },
		{ type: 'Model', loaded: true },
		{ type: 'EquipmentType', loaded: true },
		{ type: 'ConnectivityType', loaded: true },
		{ type: 'InterfaceType', loaded: true },
		{ type: 'Language', loaded: true },
		{ type: 'EquipmentDateFormat', loaded: true },
		{ type: 'ChemistryCycleDateFormat', loaded: true },
		{ type: 'DateFormatPrefix', loaded: true }
	],
	recordCombosTypes: [
		{ type: 'Location', loaded: true },
		{ type: 'Model', loaded: true },
		{ type: 'EquipmentType', loaded: true },
		{ type: 'ConnectivityType', loaded: true },
		{ type: 'InterfaceType', loaded: true },
		{ type: 'Language', loaded: true },
		{ type: 'EquipmentDateFormat', loaded: true },
		{ type: 'ChemistryCycleDateFormat', loaded: true },
		{ type: 'DateFormatPrefix', loaded: true }
	],

	columns: [
		{
			header: 'Task',
			field: 'TaskId',
			type: 'action',
			renderCell: taskIconRenderer,
			filterable: false,
			sortable: false,
			excludeOnGrid: getLicenseType
		},
		{
			header: 'Model',
			field: 'ModelName',
			width: 180,
			formField: 'ModelId',
			lookup: 'Model',
			parseFilterValue: (newValue) => {
				return Array.isArray(newValue) ? newValue.map((entry) => entry.label) : newValue?.label;
			},
			autocompleteValueFormatter: (newValue, { formik }) => {
				let val = newValue;
				if (newValue) {
					val = newValue?.id || newValue;
					formik.setFieldValue('ConnectivityType', newValue.ConnectivityType);
					formik.setFieldValue('EquipmentConnectivityType', newValue.ConnectivityType);
					formik.setFieldValue('EquipmentFamilyId', newValue.EquipmentFamilyId);
				}
				return val;
			},
		},
		{
			header: 'EquipmentType',
			field: 'EquipmentType',
			width: 150,
			filterable: true,
			formField: 'EquipmentTypeId',
			parseFilterValue: (newValue) => {
				return Array.isArray(newValue) ? newValue.map((entry) => entry.label) : newValue?.label;
			},
			lookup: 'EquipmentType',
			resets: ['TransferPdf'],
			skipEmptyFilters: true
		},
		{ field: 'EquipmentId', type: !consts.isNodeServer ? 'int' : 'string', width: 250, excludeOnGrid: true },
		{ header: 'EquipmentName', field: 'EquipmentName', width: 180, maxLength: 50 },
		{
			header: 'SNo',
			field: 'SerialNumber',
			label: 'SerialNumber',
			width: 160,
			maxLength: 100
		},
		{ header: 'MachineNumber', field: 'MachineNumber', width: 150, maxLength: 100 },
		{
			header: 'LocationName',
			field: 'LocationName',
			width: 150,
			formField: 'LocationId',
			parseFilterValue: (newValue) => {
				return Array.isArray(newValue) ? newValue.map((entry) => entry.label) : newValue?.label;
			},
			lookup: 'Location',
			skipEmptyFilters: true,
			filterable: true,
		},
		{ header: 'CycleCount', field: 'TotalCycle', width: 110, type: 'number', isNotformfield: true, align: 'right' },

		{ field: 'FirmwareRevision', width: 160, isNotformfield: true },
		{
			header: 'WellCount',
			field: 'WellCount',
			width: 145,
			type: 'number',
			align: 'left',
			headerAlign: 'left',
			valueFormatter: wellNumber,
			isNotformfield: true
		},
		{ field: 'LastConnection', width: 200, type: 'dateTime', filterType: 'date', isLocal: true, isNotformfield: true },
		{ field: 'CycleToday', width: 140, isNotformfield: true, type: 'number' },
		{
			header: 'DueCount',
			field: 'PastDue',
			width: 140,
			type: 'number',
			align: 'left',
			headerAlign: 'left',
			minValue: 0,
			isNotformfield: true,
			excludeOnGrid: getLicenseType
		},
		{
			header: 'PastDueCount',
			field: 'TaskPastDue',
			width: 150,
			type: 'number',
			align: 'left',
			headerAlign: 'left',
			minValue: 0,
			isNotformfield: true,
			excludeOnGrid: getLicenseType
		},
		{
			header: 'DateFormat',
			field: 'DateFormat',
			width: 150,
			lookup: 'EquipmentDateFormat',
			excludeOnGrid: getLicenseType,
		},
		{
			header: 'ChemistryCycleDateFormat',
			field: 'DateFormatPrefix',
			width: 150,
			lookup: 'DateFormatPrefix',
			placeholder: 'Date Format Prefix',
			excludeOnGrid: true,
			columnSize: 6
		},
		{
			field: 'ChemistryCycleDateFormat',
			width: 150,
			dependsOn: ['DateFormatPrefix'],
			lookup: 'ChemistryCycleDateFormat',
			excludeOnGrid: true,
			columnSize: 6
		},
		{
			header: 'ConnectivityType',
			field: 'Connectivity',
			formField: 'EquipmentConnectivityType',
			width: 160,
			type: 'string',
			lookup: 'ConnectivityType',
			ignoreLookupOnGridFilter: true
		},
		{
			header: 'Language',
			field: 'LanguageCodeId',
			width: 90,
			lookup: 'Language',
			excludeOnGrid: true,
			autocompleteValueFormatter: (value) => {
				if (value) {
					if (typeof value === 'object') {
						return value['id'];
					}
					return value;
				}
				return 0;
			},
		},
		{
			header: 'Domain',
			field: 'Domain',
			width: 150,
			excludeOnGrid: true,
			maxLength: 50,
		},
		{ header: 'Active', field: 'IsActive', type: 'boolean', width: 130 },
		{
			header: 'TransferPdf',
			field: 'TransferPdf',
			type: 'boolean',
			width: 130,
		},
		{
			header: 'Language',
			field: 'LanguageName',
			width: 130,
			lookup: 'Language',
			type: 'string',
			ignoreLookupOnGridFilter: true,
			isNotformfield: true
		},
		{
			header: 'Attachment',
			field: 'Attachment',
			width: 200,
			hidden: true
		}
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A2'
		}
	}
});

export { model as DashBoardequipmentModel };

export default model.createFormBase();
